import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'react-router-redux'
import localStorage from 'middleware/localStorage'
import messaging from 'middleware/messaging'
import rootReducer from 'reducer'
import initialState from 'initialState'


export const history = createHistory()


export default () => createStore(
    rootReducer,
    initialState,
    applyMiddleware(
        thunk,
        routerMiddleware(history),
        localStorage,
        messaging
    )
)
